import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Tracking } from '@panamax/app-state';
import { genericTracingTransformer } from '@shared/tracking/tracing/generic-tracing-transformer';
import { DYF_ACTIONS } from '@usf/ngrx-order';
import { map, switchMap } from 'rxjs/operators';
import { DID_YOU_FORGET_TRACING_ACTIONS } from './did-you-forget-tracing.actions';
import { dyfApiCallTrace } from './trace-models/dyf-api-call.trace';

@Injectable({
  providedIn: 'root',
})
export class DidYouForgetTracingEffects {
  getDyfProducts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DYF_ACTIONS.getDyfProducts),
      map(() => {
        const tracking: Tracking = JSON.parse(JSON.stringify(dyfApiCallTrace));
        tracking.tracing.data.isEndOfTrace = false;
        tracking.tracing.data.isStartOfTrace = true;
        tracking.tracing.transformFunc = genericTracingTransformer;
        return tracking;
      }),
      switchMap(tracking => [
        DID_YOU_FORGET_TRACING_ACTIONS.fetchDyfProducts({ tracking }),
      ]),
    ),
  );

  getDyfProductsSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DYF_ACTIONS.getDyfProductsSuccess),
      map(() => {
        const tracking = JSON.parse(JSON.stringify(dyfApiCallTrace));
        tracking.tracing.data.isEndOfTrace = true;
        tracking.tracing.data.isStartOfTrace = false;
        tracking.tracing.transformFunc = genericTracingTransformer;
        return tracking;
      }),
      switchMap(tracking => [
        DID_YOU_FORGET_TRACING_ACTIONS.fetchDyfProductsSuccess({ tracking }),
      ]),
    ),
  );

  getDyfProductsFailure$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DYF_ACTIONS.getDyfProductsError),
      map(() => {
        const tracking = JSON.parse(JSON.stringify(dyfApiCallTrace));
        tracking.tracing.data.isEndOfTrace = true;
        tracking.tracing.data.isStartOfTrace = false;
        tracking.tracing.transformFunc = genericTracingTransformer;
        return tracking;
      }),
      switchMap(tracking => [
        DID_YOU_FORGET_TRACING_ACTIONS.fetchDyfProductsFailure({ tracking }),
      ]),
    ),
  );

  constructor(private actions$: Actions) {}
}
